import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'

import { actionHandlerMap, StaticActionHandler } from '../actionHandlers'

export const resolveStaticActionHandler = (
  transactionType: TransactionOriginatorType | undefined,
  value: string,
): StaticActionHandler | undefined => {
  if (!transactionType) {
    return
  }

  const typeMap = actionHandlerMap[transactionType]
  return typeMap?.[value as keyof typeof typeMap]
}
